let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let TabSet = require("../../widgets/TabSet");
let esUtils = require("ES/utils/esUtils");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let SpeakerForm = require("../SpeakerForm");
let AuthedUserSession = require("../../../utils/AuthedUserSession");

let tabs = {
  ical: {
    name: "iCal Feed",
    render: require("./iCalFeed"),
  },
  //TODO remove after marketing reveal
  // hl: {
  //   name: "HighLevel",
  //   render: require("./Highlevel"),
  // },
  tripit: {
    name: "TripIt (defunct)",
    render: require("./TripIt"),
  },
  google_contacts: {
    name: "Google Contacts",
    render: require("./GoogleContacts"),
  },
  // google_tasks: {
  //   name: "Google Tasks",
  //   render: require("./GoogleTasks.js"),
  // },
  salesforce: {
    name: "SalesForce",
    render: require("./SalesForce"),
  },
  infusionsoft: {
    name: "Keap",
    render: require("./InfusionSoft"),
  },
  insightly: {
    name: "Insightly",
    render: require("./Insightly"),
  },
  karmacrm: {
    name: "karmaCRM",
    render: require("./KarmaCRM"),
  },
  hubspot: {
    name: "HubSpot",
    render: require("./Hubspot"),
  },
  zohocrm: {
    name: "SpeakerFlow (Zoho)",
    render: require("./ZohoCRM"),
  },
};

if (!AuthedUserSession.is_privatelabel) {
  tabs.quickbooks = {
    name: "QuickBooks",
    render: require("./Quickbooks"),
  };
  tabs.apikey = {
    name: "API key",
    render: require("./APIkey"),
  };
  tabs.stripe = {
    name: "Stripe",
    render: require("./Stripe"),
  };
}

module.exports = dd.createClass({
  getInitialState() {
    let url_args = this.props.url_args;
    console.log("url_args", url_args);
    return {
      selected_sid: -1,
      selected_tab: url_args.length > 4 ? url_args[4] : "",
    };
  },
  componentWillReceiveProps(props) {
    this.__handleDefaultSIDfromProps(props);
  },
  componentDidMount() {
    this.__handleDefaultSIDfromProps(this.props);
  },
  __handleDefaultSIDfromProps(props) {
    let { sid, Displaylists } = props;
    let my_sids = _.uniq(_.map(Displaylists && Displaylists.perspeaker, "sid"));
    let cur_sid = this.state.selected_sid;
    if (cur_sid < 0 && my_sids.length > 0) {
      sid = AuthedUserSession.getLastSelectedSID();
      this.__onSidChanged(sid > 0 ? sid : _.first(my_sids));
    }
  },
  __onSidChanged(sid) {
    this.setState({ selected_sid: _.parseInt(sid) });
  },
  __setTab(tab) {
    return _.bind(
      esUtils.wrapPreventDefault(function () {
        this.setState({ selected_tab: tab });
      }),
      this
    );
  },
  render() {
    let { Displaylists } = this.props;
    let { selected_sid, selected_tab } = this.state;
    let my_sids = _.uniq(_.map(Displaylists && Displaylists.perspeaker, "sid"));

    return LoadingWrap(
      { is_loading: _.isEmpty(Displaylists), glass: true },
      dd.div(
        { className: "Connect" },
        dd.h2(
          { style: { marginTop: 0 } },
          "Connect eSpeakers to your other cloud services"
        ),
        my_sids.length > 1
          ? SpeakerForm({
              sid: selected_sid,
              Displaylists,
              onSidChanged: this.__onSidChanged,
            })
          : null,
        dd.div({ className: "clearfix" }),
        TabSet({
          tabs: _.mapValues(
            tabs,
            function (tab, name) {
              tab.onClick = this.__setTab(name);
              return tab;
            },
            this
          ),
          selected_tab,
          render_props: {
            selected_sid,
            Displaylists,
          },
          lefty: true,
          tabs_width: 160,
        })
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/index.js